import DefaultFases from "../constants/DefaultFases";
import { languages } from "../constants/languages";
import { getPouleScores } from "./GetPouleScores";
import { sortBracketStack } from "./SortBracketStack";

export const getRankingPerDivision = (
  divisions,
  poulesAll,
  bracketsAll,
  resultSpotsAll,
  tournament,
  matches,
  teams
) => {
  let rankingPerDivision = {};
  let customPoints = {};
  for (let i in divisions) {
    let division = divisions[i];
    if (rankingPerDivision[division.id] === undefined) {
      rankingPerDivision[division.id] = {};
    }
    for (let f in division.fases || DefaultFases) {
      let elements = [],
        i = 0,
        j = 0;

      let poules = poulesAll
        .filter(
          (poule) =>
            poule.bracket === null &&
            poule.fase === Number(f) &&
            poule.division === division.id
        )
        .sort((a, b) => {
          if (a.indexNum > b.indexNum) {
            return 1;
          } else if (a.indexNum < b.indexNum) {
            return -1;
          } else {
            return a.num - b.num;
          }
        });
      let brackets = bracketsAll
        .slice()
        .filter(
          (b) =>
            b.fase === Number(f) &&
            b.division === division.id &&
            !b.subBracketTo
        )
        .sort((a, b) => {
          if (a.indexNum > b.indexNum) {
            return 1;
          } else if (a.indexNum < b.indexNum) {
            return -1;
          } else {
            return a.num - b.num;
          }
        });
      while (i < poules.length && j < brackets.length) {
        if (
          (poules[i] !== undefined ? poules[i].indexNum : poules[i].num) <=
          (brackets[j] !== undefined ? brackets[j].indexNum : brackets[j].num)
        ) {
          const poule = poules[i];
          elements.push(poule);
          i++;
        } else {
          const bracket = brackets[j];
          elements.push(bracket);
          j++;
        }
      }
      const structureElements = elements
        .concat(poules.slice(i).map((poule) => poule))
        .concat(brackets.slice(j).map((bracket) => bracket));

      let allElements = [];
      structureElements.forEach((s, i) => {
        if (s.isBracket) {
          let subBrackets = sortBracketStack(s, bracketsAll);
          subBrackets.forEach((subBracket) => {
            allElements.push(subBracket);
          });
        } else {
          allElements.push(s);
        }
      });
      let results = [];
      let groups = {
        0: [],
      };
      for (let s in allElements) {
        let structureElement = allElements[s];
        let resultSpots = resultSpotsAll.filter(
          (rs) => rs["poule" + f] === structureElement.id
        );
        if (resultSpots.length > 0 && !structureElement.singleMatch) {
          if (groups[resultSpots[0].rank] === undefined) {
            groups[resultSpots[0].rank] = [];
          }
          groups[resultSpots[0].rank].push(structureElement);
        } else {
          groups[0].push(structureElement);
        }
      }
      for (let g in groups) {
        let resultsForGroupBracket = [];
        let resultsForGroup = [];
        let group = groups[g];
        for (let s in group) {
          let structureElement = group[s];
          if (structureElement.isBracket) {
            // bracket
            let resultsForThisBracket = [];
            let poulesForBracket = poulesAll
              .filter((p) => {
                if (p.losersFinal) {
                  if (structureElement.showLosersFinal) {
                    return p.bracket === structureElement.id;
                  } else {
                    return false;
                  }
                } else {
                  return p.bracket === structureElement.id;
                }
              })
              .sort((a, b) => {
                if (a.bracketRound > b.bracketRound) {
                  return 1;
                } else if (a.bracketRound < b.bracketRound) {
                  return -1;
                } else if (a.num > b.num) {
                  return 1;
                } else if (a.num < b.num) {
                  return -1;
                } else {
                  return 0;
                }
              });
            let roundsCheckedForHide = [];
            for (let pl in poulesForBracket) {
              let poule = poulesForBracket[pl];
              const pouleMatches = matches.filter(
                (match) => match.poule === poule.id
              );
              let pouleScores = getPouleScores(tournament, pouleMatches, poule);

              for (let ps in pouleScores) {
                let pouleScore = pouleScores[ps];
                const pouleFinished = pouleScore.played === pouleMatches.length;

                pouleScore["rank"] = Number(ps);
                pouleScore["isBracket"] = true;
                pouleScore["bracketRound"] = poule.bracketRound;
                pouleScore["pouleNum"] = poule.num;
                pouleScore["pouleFinished"] = pouleFinished ? 1 : 0;
                pouleScore["isLosersFinal"] = poule.losersFinal ? 1 : 0;
                pouleScore["fromPoule"] = poule.id;
                pouleScore["fromPouleName"] = pouleFinished
                  ? languages.structure.ranksSingleMatch[ps] +
                      " " +
                      poule.name +
                      " - " +
                      structureElement.name || ""
                  : poule.name + " - " + structureElement.name || "";

                let pouleKeyName = f;
                let bracket = structureElement;
                if (bracket.subBracketTo) {
                  pouleScore["isSubBracket"] = true;
                  pouleScore["subBracketTo"] = bracket.subBracketTo;
                }
                pouleKeyName =
                  poule.bracketRound === bracket.size && !bracket.subBracketTo
                    ? poule.fase
                    : poule.fase +
                      "-" +
                      poule.bracketRound +
                      "-" +
                      poule.bracket;

                pouleScore["team"] = teams.find(
                  (t) =>
                    t["poule" + pouleKeyName] === poule.id &&
                    t["numInPoule" + pouleKeyName] ===
                      Number(pouleScore.teamKey)
                );

                if (
                  pouleScore.rank === 1 &&
                  poule.bracketRound !== 2 &&
                  roundsCheckedForHide.indexOf(poule.bracketRound) !== -1
                ) {
                  pouleScore["hideRank"] = true;
                }
                if (pouleScore.rank === 1 && poule.bracketRound !== 2) {
                  roundsCheckedForHide.push(poule.bracketRound);
                }

                resultsForThisBracket.push(pouleScore);

                Object.keys(tournament.customPoints || {}).forEach((key, i) => {
                  if (pouleScore.team && pouleScore[key]) {
                    if (customPoints[pouleScore.team.id] === undefined) {
                      customPoints[pouleScore.team.id] = {};
                    }
                    if (customPoints[pouleScore.team.id][key] === undefined) {
                      customPoints[pouleScore.team.id][key] = 0;
                    }
                    customPoints[pouleScore.team.id][key] +=
                      pouleScore[key] || 0;
                  }
                });
              }
            }
            resultsForThisBracket.sort((a, b) => {
              if (a.bracketRound > b.bracketRound) {
                return 1;
              } else if (a.bracketRound < b.bracketRound) {
                return -1;
              } else if (a.isLosersFinal > b.isLosersFinal) {
                return 1;
              } else if (a.isLosersFinal < b.isLosersFinal) {
                return -1;
              } else if (a.pouleFinished > b.pouleFinished) {
                return 1;
              } else if (a.pouleFinished < b.pouleFinished) {
                return -1;
              } else if (a.pouleNum > b.pouleNum) {
                return 1;
              } else if (a.pouleNum < b.pouleNum) {
                return -1;
              } else if (a.rank > b.rank) {
                return 1;
              } else if (a.rank < b.rank) {
                return -1;
              } else {
                return 0;
              }
            });
            resultsForGroupBracket = resultsForGroupBracket.concat(
              resultsForThisBracket
            );
          }
        }
        for (let s in group) {
          let structureElement = group[s];
          if (!structureElement.isBracket) {
            let pouleScores = getPouleScores(
              tournament,
              matches.filter((match) => match.poule === structureElement.id),
              structureElement
            );
            for (let ps in pouleScores) {
              let pouleScore = pouleScores[ps];
              pouleScore["rank"] = Number(ps);
              pouleScore["fromPoule"] = structureElement.id;
              pouleScore["fromPouleName"] =
                languages.structure.ranks[ps] + " " + structureElement.name || "";
              pouleScore["singleMatch"] = structureElement.singleMatch ? 1 : 0;
              pouleScore["pouleIndexNum"] = structureElement.indexNum;

              let pouleKeyName = f;
              pouleScore["team"] = teams.find(
                (t) =>
                  t["poule" + pouleKeyName] === structureElement.id &&
                  t["numInPoule" + pouleKeyName] === Number(pouleScore.teamKey)
              );

              resultsForGroup.push(pouleScore);

              Object.keys(tournament.customPoints || {}).forEach((key, i) => {
                if (pouleScore.team && pouleScore[key]) {
                  if (customPoints[pouleScore.team.id] === undefined) {
                    customPoints[pouleScore.team.id] = {};
                  }
                  if (customPoints[pouleScore.team.id][key] === undefined) {
                    customPoints[pouleScore.team.id][key] = 0;
                  }
                  customPoints[pouleScore.team.id][key] += pouleScore[key] || 0;
                }
              });
            }
          }
        }

        const poulesInGroupSorted = [];
        const seenPouleIds = {};
        resultsForGroup.forEach((rs) => {
          if (!seenPouleIds[rs.fromPoule]) {
            seenPouleIds[rs.fromPoule] = true;
            poulesInGroupSorted.push({
              id: rs.fromPoule,
              indexNum: rs.pouleIndexNum,
              singleMatch: !!rs.singleMatch,
            });
          }
        });
        poulesInGroupSorted.sort((a, b) => {
          if (a.indexNum > b.indexNum) {
            return 1;
          } else if (a.indexNum < b.indexNum) {
            return -1;
          } else {
            return 0;
          }
        });
        const blockNumByPouleId = {};
        let blockCounter = 0;
        let inMultiBlock = false;
        poulesInGroupSorted.forEach((p) => {
          if (p.singleMatch) {
            if (inMultiBlock) {
              blockCounter++;
              inMultiBlock = false;
            }
            blockNumByPouleId[p.id] = blockCounter;
            blockCounter++;
          } else {
            if (!inMultiBlock) {
              inMultiBlock = true;
            }
            blockNumByPouleId[p.id] = blockCounter;
          }
        });

        resultsForGroup.sort((a, b) => {
          const blockA = blockNumByPouleId[a.fromPoule];
          const blockB = blockNumByPouleId[b.fromPoule];
          if (blockA > blockB) {
            return 1;
          } else if (blockA < blockB) {
            return -1;
          } else if (a.rank > b.rank) {
            return 1;
          } else if (a.rank < b.rank) {
            return -1;
          } else if (a.pouleScore > b.pouleScore) {
            return -1;
          } else if (a.pouleScore < b.pouleScore) {
            return 1;
          } else if (a.goals > b.goals) {
            return -1;
          } else if (a.goals < b.goals) {
            return 1;
          } else if (a.goalsFor > b.goalsFor) {
            return -1;
          } else if (a.goalsFor < b.goalsFor) {
            return 1;
          } else if (a.pouleIndexNum > b.pouleIndexNum) {
            return 1;
          } else if (a.pouleIndexNum < b.pouleIndexNum) {
            return -1;
          } else {
            return 0;
          }
        });
        // console.log("sorted", resultsForGroup);
        resultsForGroup = resultsForGroupBracket.concat(resultsForGroup);
        results = results.concat(resultsForGroup);
      }
      if (rankingPerDivision[division.id][f] === undefined) {
        rankingPerDivision[division.id][f] = results;
      }
    }
  }
  // console.log(rankingPerDivision);
  let ranking = {};

  Object.keys(rankingPerDivision).forEach((key) => {
    if (ranking[key] === undefined) {
      ranking[key] = [];
    }
    let usedTeams = [];
    let usedTeamsSubBrackets = {};
    let rankingForDivision = rankingPerDivision[key];

    Object.keys(rankingForDivision)
      .reverse()
      .forEach((k) => {
        let rankingFase = rankingForDivision[k];
        rankingFase.forEach((rank) => {
          if (rank.team && usedTeams.indexOf(rank.team.id) === -1) {
            // console.log(ranking, ranking[key]);
            ranking[key].push(rank);
            usedTeams.push(rank.team.id);
          } else if (
            rank.team &&
            rank.isSubBracket &&
            (usedTeamsSubBrackets[rank.subBracketTo] || []).indexOf(
              rank.team.id
            ) === -1
          ) {
            // console.log(ranking, ranking[key]);
            let currentIndex = ranking[key].findIndex(
              (r) => (r.team || {}).id === rank.team.id
            );
            ranking[key].splice(currentIndex, 1);
            ranking[key].push(rank);
            if (usedTeamsSubBrackets[rank.subBracketTo] === undefined) {
              usedTeamsSubBrackets[rank.subBracketTo] = [];
            }
            usedTeamsSubBrackets[rank.subBracketTo].push(rank.team.id);
          }
        });
      });
  });

  return { ranking: ranking, customPoints: customPoints };
};
